import "./style.css";
import moment from "moment";
import StatusDescription from "../StatusDescription";
import StatusIcon from "../StatusIcon";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

const OrderItem = (props) => {
  const { order, history, displayContainerType, displayQuantity } = props;
  const date_format = "ll";

  const handleRowClick = () => {
    history.push("/collection-orders");
  };

  const cellStyle =
    "row-item tw-px-2 tw-no-underline tw-self-start tw-text-left tw-self-center";

  return (
    <div
      className={
        "tw-cursor-pointer tRow tw-flex tw-flex-row tw-w-full tw-no-underline tw-py-3 tw-border-b tw-font-light hover:tw-bg-tosca-alice-blue hover:tw-text-gray-900"
      }
      onClick={handleRowClick}>
      <StatusIcon order={order} />

      <StatusDescription order={order} />

      <div className={cellStyle}>
        {moment(order.requestedDeliveryDate).isValid()
          ? moment(order.requestedDeliveryDate).format(date_format)
          : ""}
      </div>

      <div className={cellStyle}>{order.shipFromLocationName}</div>
      <div className={cellStyle}>{order.orderNumber}</div>
      <div className={cellStyle}>{order.carrierName}</div>
      <div className={cellStyle}>{order.trailerNumber}</div>
      <div className={cellStyle}>{displayContainerType}</div>
      <div className={cellStyle}>{displayQuantity}</div>
    </div>
  );
};

OrderItem.propTypes = {
  order: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  displayContainerType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  displayQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default withRouter(OrderItem);
